import { register } from "@shopify/theme-sections";
import Vue from "vue";
import "../vue/filters";
import { store } from "../vue/store";
import Wishlist from "../vue/Wishlist.vue";
import { ACTION_INIT_WISHLIST } from "../vue/store/wishlist/wishlist";

const selectors = {
	wishlistHeader: "[data-header-wishlist]"
};

register("wishlist", {
	onLoad: function () {
		this.init();
	},
	init: async function () {
		await store.dispatch(`wishlist/${ACTION_INIT_WISHLIST}`);

		new Vue({
			store,
			render: (h) => h(Wishlist)
		}).$mount(this.container);
	}
});

register("wishlist-popup", {
	enabled: true,
	onLoad: function () {
		this.init();
	},
	init: async function () {
		if (window.location.href.indexOf("wishlist") > -1) {
			this.enabled = false;
		}

		if (this.enabled) {
			await store.dispatch(`wishlist/${ACTION_INIT_WISHLIST}`);

			new Vue({
				store,
				render: (h) => h(Wishlist)
			}).$mount(this.container);
		}
	}
});

(function () {
	document.addEventListener("openWishlistEvent", () => {
		document
			.querySelector(selectors.wishlistHeader)
			.classList.add("header-top__wishlist--expand");
		setTimeout(() => {
			document
				.querySelector(selectors.wishlistHeader)
				.classList.remove("header-top__wishlist--expand");
		}, 2000);
	});
})();
